import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service'
import { MatDialog } from '@angular/material/dialog'
import { SpinnerText } from 'src/app/services/message/message.enum'
import { MessageService } from 'src/app/services/message/message.service'
import {
  AimsCommonPopupEditorComponent,
  AimsCommonTableFilterType,
  AimsCommonTableHeader,
  AimsCommonTableHeaderType,
  AimsCommonTablePermissions,
} from '@aims/common-components'
import { InvConfig, InvInventoryGroup, LogReqRoutingSections, LogReqStatuses } from 'src/models'
import { Observable } from 'rxjs'
import { InventoryGroupPopupComponent } from './inventory-group-popup/inventory-group-popup.component'
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component'
import { take } from 'rxjs/operators'
import { PermissionsService } from 'src/app/services/permissions/permissions.service'

@Component({
  selector: 'app-inventory-group-config',
  templateUrl: './inventory-group-config.component.html',
  styleUrls: ['./inventory-group-config.component.css'],
})
export class InventoryGroupConfigComponent implements OnInit {
  //Spinner
  spinnerText: string = this.messageService.getSpinnerText(SpinnerText.Load);
  showSpinner: boolean = true;

  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;
  groupToEdit: InvInventoryGroup = null;

  public inventoryGroups: Observable<InvInventoryGroup> = this.transferHttp.getHot('Inventory/GetInventoryGroups');
  public inventoryConfig: InvConfig = new InvConfig();
  public reqRouting = this.transferHttp.getSingle('Logistics/GetReqRoutingSections');
  public reqStatusValues: Observable<Array<LogReqStatuses>> = this.transferHttp.getSingle('Logistics/GetReqStatuses');
  public employeeValues = this.transferHttp.getCache('employeeDropdown');

  defaultTableState = { sort:{active : 'inventoryGroupCode', direction: 'asc' }}
  disabledRO: boolean  = !this.permissions.canUpdate(this.permissions.ComponentID.InventoryConfig);

  inventoryGroupTableColumns: AimsCommonTableHeader[] = [
    { key: 'edit', label: 'Edit', type: 'button', filter: false,
      events: { click: (element) => this.handleRowEdit(element), }, hidden: this.disabledRO },
    { key: 'inventoryGroupCode', label: 'Group Code', type: 'string', width: 60,
      events: { filterAndSort: (element) =>  element.inventoryGroupCode } },
    { key: 'inventoryGroup', label: 'Group Name', type: 'string' },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN, width: 60 },
  ]

  inventoryGroupTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    export: false,
  }

  routeLookupColumns: AimsCommonTableHeader[] = [
    { key: 'routingSection', label: 'Routing Section', type: AimsCommonTableHeaderType.STRING }
  ];

  constructor(
    private transferHttp: TransferHttpService,
    private dialog: MatDialog,
    private messageService: MessageService,
    public permissions: PermissionsService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.inventoryGroups.subscribe((inventoryGroups) => {
      this.showSpinner = false
    })

    this.transferHttp.getSingle<InvConfig>('inventory/GetInventoryConfig' ).subscribe(inventoryConfig => {
      this.inventoryConfig = inventoryConfig;
    });

    this.changeDetectorRef.detectChanges();
  }

  //Event Handlers
  handleRowEdit(element) {
    const group = element as InvInventoryGroup
    this.groupToEdit = { ...group }
    this.openPopup(this.groupToEdit, false)
  }

  handleRowAdd() {
    this.groupToEdit = new InvInventoryGroup()
    this.groupToEdit.active = true;
    this.openPopup(this.groupToEdit, true)
  }

  openPopup(groupToEdit: InvInventoryGroup, isNew: boolean) {
    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      data: {
        header: 'Inventory Group',
        isNew: isNew,
        content: InventoryGroupPopupComponent,
        contentData: groupToEdit,
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.groupToEdit.inventoryGroup = dialogResult.inventoryGroupName
        this.groupToEdit.inventoryGroupCode = dialogResult.inventoryGroupCode
        this.groupToEdit.active = dialogResult.active

        this.saveInventoryGroup(isNew)
      } else {
        this.groupToEdit = null
      }
    })
  }

  private saveInventoryGroup(isNew: boolean): void {
    this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Save, 'Inventory Group')
    this.showSpinner = true

    if (!isNew) {
      this.transferHttp.put('inventory/SaveInventoryGroup', this.groupToEdit).subscribe(
        (retVal) => {
          this.showSpinner = false
          this.refreshInventoryGroups()
        },
        (error) => (this.showSpinner = false)
      )
    } else {
      this.transferHttp.post('inventory/CreateInventoryGroup', this.groupToEdit).subscribe(
        (retVal) => {
          this.showSpinner = false
          this.refreshInventoryGroups()
        },
        (error) => (this.showSpinner = false)
      )
    }
  }

  public refreshInventoryGroups() {
    this.inventoryGroups = this.transferHttp.getHot('Inventory/GetInventoryGroups')
  }

  handleRoutingCompontLookupChange(componentObj: any, routingSection: LogReqRoutingSections, control) {
    this.updateConfig();
  }

  updateConfig() {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.transferHttp.put('Inventory/SaveInventoryConfig', this.inventoryConfig).pipe(take(1)).subscribe({
      next: (ret) => {
        this.showSpinner = false;
      },
      error: e => {
        this.showSpinner = false;
      }
    });
  }

}
